import styled from 'styled-components'

interface iProps {
  isExpanded: boolean
  isExpandedItems?: boolean
  itemAtual?: boolean
  isDisabled?: boolean
  qtdItems?: number
}

export const SidebarContainer = styled.div<iProps>`
  min-width: ${(props) => (props.isExpanded ? '310px' : '24px')};
  background-color: var(--c1);
  top: 0px;
  border: 1px solid var(--AzulOpaco);
  border-right: ${(props) => (props.isExpanded ? '2px' : '66px')} solid var(--Azul);
  color: black;
  min-height: ${(props) => ((((props.qtdItems ?? 0) * 4.25) + 10) > 44 ? `${(((props.qtdItems ?? 0) * 4.25) + 10)}rem` : '44rem')};
  display: flex;
  flex-direction: column;
  position: relative;
  align-items: ${(props) => (props.isExpanded ? 'flex-start' : 'center')};
  transition: width 0.45s ease;
`

export const ToggleButton = styled.button<iProps>`
  border: 2px solid var(--Azul);
  font-size: 14px;
  color: black;
  width: 32px;
  height: 32px;
  cursor: pointer;
  ${(props) => (props.isExpanded ? '' : 'position: absolute; right: -32px; top: 1rem;')}
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  &:hover {
    background-color: var(--Azul);
    color: white;
  }
`

export const Menu = styled.ul<{ isSticky: boolean, topPx: number, expanded: boolean }>`
  list-style: none;
  position: sticky;
  top: 0;
  max-height: calc(99.9vh - ${props => props.topPx}px);
  overflow-y: auto;
  overflow-x: hidden;
  border-bottom: 3px solid var(--c2);
  padding: 1rem 0;
  display: flex;
  flex-direction: column;
  gap: .75rem;
  box-sizing: border-box;
  width: ${props => props.expanded ? '100%' : '0'};

  ${props => props.isSticky ? 'max-height: 100vh;' : ''}
`

export const MenuItem = styled.li<iProps>`
  padding: ${(props) => (props.isExpanded ? '10px' : '0')};
  font-size: 14px;
  line-height: 16px;
  font-weight: 600;
  margin: ${(props) => (props.isExpanded ? '0px 12px' : '0')};
  gap: .5rem;
  align-items: center;
  height: 52px;
  transition: .5s;
  border-radius: 4px;
  border: 1px solid var(--c6);
  box-sizing: border-box;
  box-shadow: var(--SombraBackground);
  display: ${(props) => (props.isExpanded ? 'flex' : 'none')};
  opacity: ${(props) => (props.isExpandedItems ? '1' : '0')};
  width: ${(props) => (props.isExpandedItems ? '272px' : '0px')};
  cursor: ${(props) => (props.isExpanded ? 'pointer' : 'none')};
  ${(props) => (props.itemAtual ? 'background-color: var(--Azul); color: white;' : `border-left: 3px solid ${props.color}); border-bottom: 3px solid ${props.color});`)}
  ${props => !props.isDisabled ? '&:hover { background-color: var(--Azul); color: white !important; border-left: none; }' : ''}
`
